import { render, staticRenderFns } from "./DocSolution.vue?vue&type=template&id=ebddb996"
import script from "./DocSolution.vue?vue&type=script&lang=js"
export * from "./DocSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports